
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function ResourcesPage() {
  const resources = [
    {
      category: 'Documentation',
      items: [
        {
          title: 'Loan Guidelines Quick Reference',
          description: 'Comprehensive quick reference guide for all major agency guidelines',
          type: 'PDF',
          downloadUrl: '#',
          icon: 'ri-file-pdf-line'
        },
        {
          title: 'Agency Comparison Chart',
          description: 'Side-by-side comparison of requirements across Fannie Mae, Freddie Mac, FHA, and VA',
          type: 'PDF',
          downloadUrl: '#',
          icon: 'ri-file-chart-line'
        },
        {
          title: 'Property Type Matrix',
          description: 'Complete matrix of property types and their eligibility by agency',
          type: 'Excel',
          downloadUrl: '#',
          icon: 'ri-file-excel-line'
        }
      ]
    },
    {
      category: 'Training Materials',
      items: [
        {
          title: 'New Loan Officer Training Guide',
          description: 'Complete training curriculum for new mortgage professionals',
          type: 'PDF',
          downloadUrl: '#',
          icon: 'ri-graduation-cap-line'
        },
        {
          title: 'Underwriting Best Practices',
          description: 'Industry best practices and common pitfalls to avoid',
          type: 'Video',
          downloadUrl: '#',
          icon: 'ri-play-circle-line'
        },
        {
          title: 'Compliance Checklist',
          description: 'Step-by-step compliance verification checklist',
          type: 'PDF',
          downloadUrl: '#',
          icon: 'ri-checkbox-line'
        }
      ]
    },
    {
      category: 'Tools & Calculators',
      items: [
        {
          title: 'DTI Calculator',
          description: 'Debt-to-income ratio calculator with agency-specific requirements',
          type: 'Tool',
          downloadUrl: '#',
          icon: 'ri-calculator-line'
        },
        {
          title: 'Income Documentation Worksheet',
          description: 'Comprehensive worksheet for documenting borrower income',
          type: 'Excel',
          downloadUrl: '#',
          icon: 'ri-file-list-line'
        },
        {
          title: 'Property Eligibility Checker',
          description: 'Quick tool to check property eligibility across agencies',
          type: 'Tool',
          downloadUrl: '#',
          icon: 'ri-home-gear-line'
        }
      ]
    },
    {
      category: 'Industry Updates',
      items: [
        {
          title: 'Monthly Guidelines Update',
          description: 'Latest changes and updates to agency guidelines',
          type: 'Newsletter',
          downloadUrl: '#',
          icon: 'ri-newspaper-line'
        },
        {
          title: 'Regulatory Changes Alert',
          description: 'Real-time alerts for important regulatory changes',
          type: 'Email',
          downloadUrl: '#',
          icon: 'ri-notification-line'
        },
        {
          title: 'Industry Trends Report',
          description: 'Quarterly analysis of mortgage industry trends and impacts',
          type: 'PDF',
          downloadUrl: '#',
          icon: 'ri-line-chart-line'
        }
      ]
    }
  ];

  const webinars = [
    {
      title: 'Understanding FHA Guidelines Changes for 2024',
      date: 'December 15, 2024',
      time: '2:00 PM EST',
      duration: '60 minutes',
      presenter: 'Sarah Johnson, Senior Underwriter',
      status: 'upcoming',
      registrationUrl: '#'
    },
    {
      title: 'VA Loan Appraisal Requirements Deep Dive',
      date: 'December 8, 2024',
      time: '1:00 PM EST',
      duration: '45 minutes',
      presenter: 'Michael Chen, VA Specialist',
      status: 'upcoming',
      registrationUrl: '#'
    },
    {
      title: 'Fannie Mae DU Updates and Best Practices',
      date: 'November 28, 2024',
      time: '3:00 PM EST',
      duration: '90 minutes',
      presenter: 'Lisa Rodriguez, Compliance Expert',
      status: 'recorded',
      registrationUrl: '#'
    }
  ];

  return (
    <div className="min-h-screen bg-slate-900">
      <Header />
      
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-slate-800 to-slate-900 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Resources & Training
            </h1>
            <p className="text-xl text-slate-300 max-w-3xl mx-auto">
              Access comprehensive training materials, tools, and industry updates to stay ahead in the mortgage industry
            </p>
          </div>
        </div>
      </div>

      {/* Resources Grid */}
      <div className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {resources.map((category) => (
            <div key={category.category} className="mb-16">
              <h2 className="text-2xl font-bold text-white mb-8">{category.category}</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {category.items.map((item) => (
                  <div key={item.title} className="bg-slate-800 rounded-lg p-6 border border-slate-700 hover:border-emerald-500 transition-colors">
                    <div className="flex items-start space-x-4">
                      <div className="w-12 h-12 bg-emerald-600 rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className={`${item.icon} text-white text-xl`}></i>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-lg font-semibold text-white mb-2">{item.title}</h3>
                        <p className="text-slate-400 mb-4">{item.description}</p>
                        <div className="flex items-center justify-between">
                          <span className="text-sm text-emerald-400 font-medium">{item.type}</span>
                          <a
                            href={item.downloadUrl}
                            className="bg-emerald-600 text-white px-4 py-2 rounded-lg hover:bg-emerald-500 transition-colors text-sm font-medium cursor-pointer whitespace-nowrap"
                          >
                            <i className="ri-download-line mr-2"></i>
                            Download
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Webinars Section */}
      <div className="bg-slate-800 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-white mb-4">Upcoming Webinars</h2>
            <p className="text-slate-300 text-lg">
              Join our expert-led webinars to stay current with industry changes and best practices
            </p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
            {webinars.map((webinar) => (
              <div key={webinar.title} className="bg-slate-900 rounded-lg p-6 border border-slate-700">
                <div className="flex items-center justify-between mb-4">
                  <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                    webinar.status === 'upcoming' 
                      ? 'bg-emerald-600 text-white' 
                      : 'bg-slate-700 text-slate-300'
                  }`}>
                    {webinar.status === 'upcoming' ? 'Upcoming' : 'Recorded'}
                  </span>
                  <span className="text-slate-400 text-sm">{webinar.duration}</span>
                </div>
                
                <h3 className="text-lg font-semibold text-white mb-3">{webinar.title}</h3>
                
                <div className="space-y-2 mb-6">
                  <div className="flex items-center text-slate-400 text-sm">
                    <i className="ri-calendar-line mr-2"></i>
                    {webinar.date}
                  </div>
                  <div className="flex items-center text-slate-400 text-sm">
                    <i className="ri-time-line mr-2"></i>
                    {webinar.time}
                  </div>
                  <div className="flex items-center text-slate-400 text-sm">
                    <i className="ri-user-line mr-2"></i>
                    {webinar.presenter}
                  </div>
                </div>
                
                <a
                  href={webinar.registrationUrl}
                  className="w-full bg-emerald-600 text-white py-2 px-4 rounded-lg hover:bg-emerald-500 transition-colors font-medium text-center block cursor-pointer whitespace-nowrap"
                >
                  {webinar.status === 'upcoming' ? 'Register Now' : 'Watch Recording'}
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
